import { useRef } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import './Tabs.css';

function Tabs({ tabs, active, onChange, layoutId = 'ds-tabs-underline', variant = 'underline' }) {
  const reduceMotion = useReducedMotion();
  const tabRefs = useRef({});
  const isPill = variant === 'pill';

  const handleKeyDown = (e, index) => {
    let nextIndex = null;
    if (e.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
    if (e.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
    if (e.key === 'Home') nextIndex = 0;
    if (e.key === 'End') nextIndex = tabs.length - 1;

    if (nextIndex !== null) {
      e.preventDefault();
      const nextTab = tabs[nextIndex];
      onChange(nextTab.key);
      tabRefs.current[nextTab.key]?.focus();
    }
  };

  return (
    <div className={`ds-tabs ${isPill ? 'ds-tabs-pill' : ''}`} role="tablist">
      {tabs.map((tab, index) => {
        const isActive = tab.key === active;
        return (
          <button
            key={tab.key}
            ref={(el) => (tabRefs.current[tab.key] = el)}
            role="tab"
            aria-selected={isActive}
            tabIndex={isActive ? 0 : -1}
            className={`ds-tab ${isPill ? 'ds-tab-pill' : ''} ${isActive ? 'ds-tab-active' : ''}`}
            onClick={() => onChange(tab.key)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          >
            {isActive && (
              <motion.div
                className={isPill ? 'ds-tab-pill-bg' : 'ds-tab-underline'}
                layoutId={layoutId}
                transition={reduceMotion ? { duration: 0 } : { duration: 0.2, ease: [0.4, 0, 0.2, 1] }}
              />
            )}
            <span className="ds-tab-content">
              {tab.label}
              {tab.count !== undefined && <span className="ds-tab-count">{tab.count}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
